// noinspection JSUnresolvedVariable

import {getSingleInputElementByNameV3} from "../helpers/inputs/forms/formInputHelpers";
import {setupFileUploader} from "../common/filesUploader";
import Axios from "axios";
import {handleAjaxSuccess} from "../helpers/SwalHelper";
import handleAjaxError from "../helpers/handleAjaxError";
import {hideLoading, showLoading} from "../helpers/loading";

function initCustomerChangeOrdersView() {
	// Init
	/** @var {HTMLButtonElement} */
	const acceptButton = document.querySelector('.accept-change-request-button');
	if (acceptButton) {
		acceptButton.addEventListener('click', () => {
			handleAcceptRequest(acceptButton.dataset.route);
		})
	}

	/** @var {HTMLInputElement} */
	const signatureInput = getSingleInputElementByNameV3(document.body, 'signature');
	if (signatureInput) {
		signatureInput.addEventListener('change', updateAcceptButtonStatus);
		signatureInput.addEventListener('keyup', updateAcceptButtonStatus);
	}

	// Init file gallery
	const filesContainer = document.querySelector('.change-order-files');
	if (filesContainer) {
		const files = JSON.parse(filesContainer.dataset.files);

		setupFileUploader(
			{
				target: filesContainer,
				height: 140, // Compact view ~ 2 files before needing to scroll
			},
			null,
			files,
		)
	}


	// Methods
	function updateAcceptButtonStatus() {
		if (!acceptButton || !signatureInput) {
			return;
		}

		acceptButton.disabled = getSignatureString() === '';
	}

	function getSignatureString() {
		if (!signatureInput) {
			return '';
		}

		return signatureInput.value.trim();
	}

	function handleAcceptRequest(route) {
		if (!route) {
			console.error('No route provided for accept request');
			return;
		}

		const signature = getSignatureString();
		if (!signature) {
			// This shouldn't happen as the button should be disabled
			alert('Please enter your full name to approve the change order');
			return;
		}

		// Confirm the action
		Swal.fire({
			title: 'Approve Change Order',
			text: 'Are you sure you want to approve this change order?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Yes, approve it',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.isConfirmed) {
				showLoading();

				const data = {
					signature: signature
				};

				Axios.post(route, data)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(hideLoading);
			}
		});
	}
}

export {initCustomerChangeOrdersView}
